import { Reducer } from 'redux';
import { UserGroupState } from '../configs/types';
import { SIGN_OUT } from '../../../actions/authActions';
import {
  FETCH_USER_GROUPS_SUCCESS,
  FETCH_USER_GROUPS_FAILURE,
} from '../actions/userGroupActions';

const initialState: UserGroupState = {
  groups: [],
  hasUserGroup: false,
};

const userGroupReducer: Reducer = (
  state: UserGroupState = initialState,
  action: { type: string; payload?: any },
) => {
  let nextState = { ...state };
  const { type, payload } = action;
  switch (type) {
    case SIGN_OUT:
      nextState = { ...initialState };
      return nextState;
    case FETCH_USER_GROUPS_SUCCESS:
      nextState = {
        ...state,
        groups: payload.groups,
        hasUserGroup: true,
      };
      return nextState;
    case FETCH_USER_GROUPS_FAILURE:
      nextState = {
        ...state,
        hasUserGroup: false,
        error: action.payload.error,
      };
      return nextState;
    default:
      return nextState;
  }
};

export { userGroupReducer };
